export default () => {
  const data = {
    event_name: 'tapped_select_field',
    button_name: 'property_type',
    page_section: 'search_properties',
    name_of_the_page_viewed: 'home_personal',
  };
  return data;
};
